import { get } from './commonFetch';

export interface ApiFlightHop {
  number?: string;

  airline?: {
    code?: string;
    full?: string;
    name?: string;
  };

  departureAirportCode?: string;
  arrivalAirportCode?: string;

  departureTime?: string;
  arrivalTime?: string;

  flightHistoryId?: number;

  hopIssues?: any[];
  connectionIssues?: any[];

  statusCode?: string;
  statusMessage?: string;
  statusIndicator?: string;

  departureGate?: string | null;
  departureTerminal?: string | null;
  arrivalGate?: string | null;
  arrivalTerminal?: string | null;

  scheduledGateDepartureDateTime?: string;
  estimatedGateDepartureDateTime?: string;
  actualGateDepartureDateTime?: string;

  scheduledRunwayDepartureDateTime?: string;
  estimatedRunwayDepartureDateTime?: string;
  actualRunwayDepartureDateTime?: string;

  scheduledGateArrivalDateTime?: string;
  estimatedGateArrivalDateTime?: string;
  actualGateArrivalDateTime?: string;

  scheduledRunwayArrivalDateTime?: string;
  estimatedRunwayArrivalDateTime?: string;
  actualRunwayArrivalDateTime?: string;

  minutesSinceDeparture?: number;

  departureAirportTimeZoneRegionName?: string;
  arrivalAirportTimeZoneRegionName?: string;

  scheduledFlightTime?: number;
  departureDelay?: number;
  arrivalDelay?: number;
  differenceInDelay?: number;
  inconsistentDelay?: boolean;

  departureAirportFull?: string;
  departureAirportCityState?: string;
  departureAirportCodeCityStateCountry?: string;
  departureAirportCity?: string;
  departureAirportUTCOffsetHours?: number;

  arrivalAirportFull?: string;
  arrivalAirportCityState?: string;
  arrivalAirportCodeCityStateCountry?: string;
  arrivalAirportCity?: string;
  arrivalAirportUTCOffsetHours?: number;

  connection?: {
    inArrivalAirportCode?: string;
    connectionTime?: number;
    minConnectionTime?: number;
    arrivalGate?: string | null;
    departureGate?: string | null;
    statusMessage?: string;
    statusIndicator?: string;
  };
}


export interface ApiFlight {
  number: string;
  airline: { code: string; name?: string };
  departureAirportCode?: string;
  departureTime?: string;
  departureAirportCodeCityStateCountry?: string;
  arrivalAirportCode?: string;
  arrivalTime?: string;
  arrivalAirportCodeCityStateCountry?: string;
  utcDepartureTime?: string;
  utcArrivalTime?: string;
  hops?: ApiFlightHop[];
  issues?: any[]; // issues attached to this specific flight (optional)
  mct?: number;
}

export interface ApiFlights {
  flight: ApiFlight,
  hops?: ApiFlightHop[];
  issuesCount?: number;
}

export interface ApiLeg {
  flights: ApiFlights[];
  departureAirportCode: string;
  departureAirportCodeCityStateCountry: string;
  arrivalAirportCode: string;
  arrivalAirportCodeCityStateCountry: string;
}

export interface ApiTrip {
  id: string;
  recordLocator?: string;
  groupName?: string;
  passengers?: { firstName?: string; lastName?: string }[];
  legs?: ApiLeg[];
  issues?: any[]; 
}

// --- API Functions ---
export async function fetchTripById(id: string): Promise<ApiTrip> {
  const uri = `/api/travelermap/${id}`;
  return await get<ApiTrip>(uri);
}



